/**
 * @module websocket.event.handlers.airlines.airline-added
 */
import { store } from '../../../../state/store'
import { setAirlineListUpdated } from '../../../../state/websocket.slice'

export default function handleAirlineAdded(context) {
  const { payload: { channelId, data } = {} } = context
  if (!data || !channelId) {
    return
  }

  const isSubscribed = store
    .getState()
    ?.websocket?.subscriptions?.some((channel) => channel === channelId)

  console.log('#handleAirlineAdded', {
    isSubscribed,
    channelId,
    data,
  })

  if (isSubscribed) {
    store.dispatch(setAirlineListUpdated(data))
  }
} 